<div class="mb-20">
  <div class="input-group custom-file-upload" *ngIf="!files.length">
    <input #inputFile [hidden]="true" (change)="onChangeInput($event.target.files)" type="file" [attr.accept]="accept.length ? accept.join(',') : '*/*'"
      [multiple]="maxFiles > 1" type="file" class="form-control" />
    <label (click)="onClickButtonSelectFile()" class="upload-file-content justify-content-center" [ngClass]="{'drag-over': isDragOver}">
      <span class="d-inline-block mb-0_8 icon-import-from-file"></span>
      <span class="d-inline-block mb-0_8 select-text"> Select or drop file{{ maxFiles > 1 ? 's' : '' }}
        {{ acceptExtensions ? ('(' + acceptExtensions.join(', ') + ')') : '' }}</span>
      <span *ngIf="maxSize" class="d-inline-block mb-0_8 size-text text-neutral-n9">{{ maxSize | size: 0 }} max size</span>
    </label>
  </div>
  <div *ngIf="files.length" class="file-download pt-10">
    <div *ngFor="let file of files" class="file-download-box d-flex justify-content-between">
      <div class="left-col d-flex">
        <div class="icon-holder">
          <span class="icon-file"></span>
        </div>
        <div class="file-name">{{ file.name }}</div>
      </div>
      <div class="right-col d-flex">
        <div class="file-size">{{ file.size | size }}</div>
        <div class="file-action d-flex">
          <!-- <span class="progress"><span class="icon-wait"></span></span> -->
          <span class="progress completed"><span class="icon-done"></span></span>
          <span (click)="onClickRemoveFile(file)" class="delete far fa-trash-alt"></span>
        </div>
      </div>
    </div>
  </div>
</div>
